import * as React from "react";
import {
  Box
} from "@chakra-ui/react";


interface Props {
  children: React.ReactNode
  background?: object | string
  padding?: object | string
}


export const SectionWrapper: React.FC<Props> = ( props ) => {
  return (
    <Box
      as="section"
      position="relative"
      w="100%"
      background={ props.background }
      padding={ props.padding }
    >
      { props.children }
    </Box>
  )
}
